<template>
  <simple-edit-base
    ref="simpleEditBase"
    v-bind="$data"
  />
</template>
<script>
import SimpleEditBase from "@/components/simple-edit/base.vue";
import planCommon from "@/plans/ZM_AI_COMPANION/mixin.js";

export default {
  name: "AICompanionEditSimple",
  components: { SimpleEditBase },
  mixins: [planCommon],
  data() {
    return {
      licensesMax: 9999,
    };
  }
};
</script>
